import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import CLabel from '../../../../../Common/CLabel';
import { mergeStyleSets, TooltipHost } from '@fluentui/react';
import { TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { css } from '@fluentui/react/lib/Utilities';
import { useTranslation } from "react-i18next";

function DestinationParties(props) {
    const { t } = useTranslation();
    
    const objMessage = props.objMessage;

    const classNames = mergeStyleSets({
        overflow: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: 180,
        },
        parent: {
            selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });

    //Render de componente.
    return (
            <Row className='ps-3 pe-3'  style={{borderTop: "1px solid #999"}} >
                <Col xl={12}>
                    <CLabel labelText={ t('data-lang-lbl-sendedtopartys') } />
                </Col>
                {
                    objMessage.l_partys_to && objMessage.l_partys_to.map((party, index) => (
                        <Col key={index} xl={4} className='p-1'>
                            <Card identifier={party.sectionPartyMessageId}>
                                <Card.Body className='p-1'>
                                    <Row>
                                        <Col>
                                            <div>
                                                <TooltipHost
                                                    overflowMode={TooltipOverflowMode.Self}
                                                    // The TooltipHost itself will overflow
                                                    hostClassName={css(classNames.overflow)}
                                                    content={party.partyName}
                                                    onTooltipToggle={false}
                                                    styles={{
                                                        root: { display: 'block' },
                                                    }}
                                                    // In this mode, aria-describedby is automatically added/removed based on tooltip visibility
                                                    >
                                                    <div style={{ fontSize: "12px" }}><b>{ t('data-lang-lbl-name') }</b>: {party.partyName}</div>
                                                </TooltipHost>
                                            </div>
                                            <div style={{ fontSize: "12px"}}>

                                                <div>
                                                    {
                                                        party.answeredStatusName === "data-lang-sbsectionpartymessage-answered0" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--MailAlert` } ></i> : <></>
                                                    }
                                                    {
                                                        party.answeredStatusName === "data-lang-sbsectionpartymessage-answered1" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--Mail` } ></i> : <></>
                                                    }
                                                    {
                                                        party.answeredStatusName === "data-lang-sbsectionpartymessage-answered2" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--SendMirrored` } ></i> : <></> 
                                                    }
                                                    {
                                                        party.answeredStatusName === "data-lang-sbsectionpartymessage-answered3" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--ReminderTime` } ></i> : <></>
                                                    }
                                                    {
                                                        party.answeredStatusName === "data-lang-sbsectionpartymessage-answered4" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--EventDateMissed12` } ></i> : <></>
                                                    }
                                                    &nbsp;{t(party.answeredStatusName)}
                                                </div>
                                                <div>
                                                {
                                                    party.readStatusName === "data-lang-sbsectionpartymessage-read0" ?
                                                    <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--RadioBtnOff` } ></i> : <></>
                                                }
                                                {
                                                    party.readStatusName === "data-lang-sbsectionpartymessage-read1" ?
                                                    <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--MailAlert` } ></i> : <></>
                                                }
                                                {
                                                    party.readStatusName === "data-lang-sbsectionpartymessage-read2" ?
                                                    <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--Read` } ></i> : <></>
                                                }
                                                &nbsp;{t(party.readStatusName)}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                }
            </Row>
    );
}

export default DestinationParties;